import type { IncidentDatabase } from "../../../../../types";

type Props = {
  droppableId: 'in_progress' | 'resolved';
  title: string;
  incidents: IncidentDatabase[];
  isResolvedColumn: boolean;
  onStatusChange?: (incidentId: string, newStatus: 'in_progress' | 'resolved') => void;
  onAddIncident?: () => void;
};

export function useIncidentKanbanColumn(props: Props) {
  const count = props.incidents.length;
  const state = props.isResolvedColumn ? 'terminé' : 'en cours';
  const countBadge = `${count} incident${count > 1 ? 's' : ''} ${state}${count > 1 ? 's' : ''}`;

  return {
    count,
    countBadge,
  };
}
